var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',{staticClass:"child-devices-modal",attrs:{"height":"600","show":_vm.show},on:{"close":_vm.close}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n    "+_vm._s(_vm.$t("devicesStatus"))+"\n  ")]),_c('child-devices',{attrs:{"child-id":_vm.fromBus.childId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }